/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Undocumented experimental feature: inline editing.
 *
 * TODO: support more types of inputs: checkbox, radio, ...
 * TODO: Mirror input attributes from the host to the actual input: size, min, max, placeholder, ...
 */


import {Component} from '@angular/core';
import {StackControl} from './stack-control';
import {StackView} from './stack-view';
export class StackInput extends StackControl {
    type: string = "text";
/**
 * @param {?} stackView
 */
constructor(public stackView: StackView) {
        super(stackView);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-stack-input",
    inputs: ["model: clrModel", "type"],
    outputs: ["modelChange: clrModelChange"],
    template: `
        <span *ngIf="!stackView.editing">{{model}}</span>
        <input [type]="type" *ngIf="stackView.editing" [(ngModel)]="model"/>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: StackView, },
];
}

function StackInput_tsickle_Closure_declarations() {
/** @type {?} */
StackInput.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StackInput.ctorParameters;
/** @type {?} */
StackInput.prototype.type;
/** @type {?} */
StackInput.prototype.stackView;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
